export interface ServerEvent {
	type: string;
	data?: unknown;
	transcript?: string;
	name?: string;
	arguments?: string;
	session?: unknown;
	response?: unknown;
	modalities?: string[];
	instructions?: string;
}

export interface RealtimeSessionResponse {
	client_secret: { value: string };
	model: string;
}

export type ConnectionStatus = 'disconnected' | 'connecting' | 'connected' | 'error';

export interface SessionConfig {
	input_audio_transcription?: { model: string, language: string };
	turn_detection?: { type: string; create_response?: boolean };
	instructions?: string;
}

export interface MemoryEntry {
	role: 'user' | 'assistant';
	text: string;
	timestamp: Date;
}

export interface AiAssistantConfig {
	maxMemoryLines: number;
	maxMemoryLength: number;
	baseUrl: string;
	retryAttempts: number;
	retryDelay: number;
	debounceTime: number;
}

export interface NavigationRequest {
	route: string;
	projectName?: string;
}

export interface CreateProjectRequest {
	projectName: string;
}

export interface SearchRequest {
	query: string;
}

export interface InstructionRequest {
	instruction: string;
}

export interface ResponseCreateEvent {
	type: 'response.create';
	response: {
		modalities: string[];
		instructions?: string;
	};
}

export interface SessionUpdateEvent {
	type: 'session.update';
	session: SessionConfig;
}

export function isServerEvent(data: unknown): data is ServerEvent {
	return typeof data === 'object' &&
		data !== null &&
		'type' in data &&
		typeof (data as Record<string, unknown>).type === 'string'
}
